import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { CommonLoading } from 'react-loadingg';
import { Bulletins, Header } from '../components/Bulletin';

const BulletinBoard = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [bulletins, setBulletins] = useState([]);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Bulletin Board') &&
                        item.permissionType.includes('view'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }
        }
    }, [props.loginList]);

    useEffect(() => {
        const getBulletins = async () => {
            const bulletinFromServer = await fetchBulletins();
            setBulletins(bulletinFromServer);
        };

        getBulletins();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Fetch Bulletin
    const fetchBulletins = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/bulletinboard/getbulletin'
        );
        const data = await res.json();
        return data.BBoardList;
    };

    // Delete Bulletin
    const deleteBulletin = (bulletin) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/bulletinboard/deletebulletin';

        const bulletinDetails = {
            bbID: bulletin.id,
            deletedBy: bulletin.deletedBy,
        };
        axios
            .post(url, bulletinDetails)
            .then(
                (response) => alert('Bulletin has been successfully deleted!'),
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const BulletinList = () => {
        return (
            <>
                {bulletins.length > 0 ? (
                    <Bulletins
                        bulletins={bulletins}
                        onDelete={deleteBulletin}
                        badgeID={props.badgeID}
                        loginList={props.loginList}
                    />
                ) : (
                    'No bulletins to show'
                )}
            </>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <Header />
                        <BulletinList />
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default BulletinBoard;
